export enum TabCode {
    LOCATION, BOOKMARK_LIST, BOOKMARK_MANAGER
}